import { createFeature } from "./createFeature";
import { createFeatureHook } from "./createFeatureHook";

interface FeatureRequest {
  name: string;
  version: number;
}

const createFeaturesQueryRequest = (
  modulesFeaturesNames: FeatureRequest[][],
  legacyModulesTestAliases: string[][],
) => {
  const activeV1Features = (legacyModulesTestAliases || [[]]).reduce(
    (activeAliases, aliases) => {
      if (Array.isArray(aliases)) {
        aliases.forEach((alias) => {
          if (!activeAliases.find((feature) => feature.name === alias)) {
            activeAliases.push({ name: alias, version: 1 });
          }
        });
      }

      return activeAliases;
    },
    [] as Array<FeatureRequest>,
  );
  const activeFeaturesAcc = (modulesFeaturesNames || [[]]).reduce(
    (activeFeatures, features) => {
      if (Array.isArray(features)) {
        features.forEach((feature) => {
          const sameFeatures = activeFeatures.filter(
            (existentFeature) => existentFeature.name === feature.name,
          );
          if (
            sameFeatures.some(
              (sameFeature) => sameFeature.version === feature.version,
            )
          ) {
            return;
          }
          activeFeatures.push(feature);
        });
      }

      return activeFeatures;
    },
    activeV1Features,
  );
  return {
    aliases: activeFeaturesAcc,
  };
};

export { createFeature, createFeatureHook, createFeaturesQueryRequest };
